import {
    Outlet,
    Route,
    Routes,
    useLocation,
    useNavigate
} from 'react-router-dom'

import { useMobile } from 'context/isMobile'
import HomeRouter from 'helpers/HomeRouter'
import { useRenderSettingsRoutes } from 'helpers/settings/settings-routes'
import BasicLayout from 'layouts/basicLayout/BasicLayout';
import {
    Analytics,
    Auth,
    Conversation,
    Creators,
    Earnings,
    EditPost,
    Fans,
    Feed,
    Friends,
    HowTo,
    // Inbox,
    LikesHistory,
    List,
    Lists,
    Live,
    Media,
    MediaCategories,
    MediaPlaylists,
    Menu,
    NewMessage,
    NewPost,
    NewStory,
    NotFound,
    Notifications,
    Playlists,
    Post,
    Profile,
    PublicFriends,
    Purchases,
    Referrals,
    SchedulePage,
    StreamsArchive,
    Subscriptions,
    Support,
    Transactions,
    UserActivity,
    Vault,
    VerifyEmail,
    VerifyMyAgeCallback,
    Watch,
    WatchHistory
} from 'pages'
import { GoogleCallback } from 'pages/auth/view/GoogleCallback/GoogleCallback'
import { TwitterLogin } from 'pages/auth/view/TwitterLogin'
import Discover from 'pages/discover'
import { Article } from 'pages/howTo/pages/Article'
import { AuthModalProvider } from 'pages/landingPage/components/AuthmodalContext'
import LandingPage from 'pages/landingPage/LandingPage'
import Main from 'pages/landingPage/components/main'
import AcceptableUseModal from 'pages/landingPage/modals/AcceptableUseModal'
import BiometricNoticeModal from 'pages/landingPage/modals/BiometricNoticeModal'
import CCPAPolicyModal from 'pages/landingPage/modals/CCPAPolicyModal'
import ComplaintsPolicyModal from 'pages/landingPage/modals/ComplaintsPolicyModal'
import ContentModerationPolicyModal from 'pages/landingPage/modals/ContentModerationPolicyModal'
import CookiePolicyModal from 'pages/landingPage/modals/CookiePolicyModal'
import CreatorTermsModal from 'pages/landingPage/modals/CreatorTermsModal'
import DMCAModal from 'pages/landingPage/modals/DMCAModal'
import FanCreatorContractModal from 'pages/landingPage/modals/FanCreatorContractModal'
import PrivacyPolicyModal from 'pages/landingPage/modals/PrivacyPolicyModal'
import ReferralTermsModal from 'pages/landingPage/modals/ReferralTermsModal'
import TermsModal from 'pages/landingPage/modals/TermsModal'
import USCModal from 'pages/landingPage/modals/USCModal'
import AcceptableUse from 'pages/landingPage/terms/acceptableuse'
import BiometricNotice from 'pages/landingPage/terms/biometricnotice'
import CCPAPolicy from 'pages/landingPage/terms/ccpapolicy'
import ComplaintsPolicy from 'pages/landingPage/terms/complaintspolicy'
import ContentModerationPolicy from 'pages/landingPage/terms/contentmoderationpolicy'
import CookiePolicy from 'pages/landingPage/terms/cookiepolicy'
import CookieTable from 'pages/landingPage/terms/cookietable'
import CreatorTerms from 'pages/landingPage/terms/creatorterms'
import DMCA from 'pages/landingPage/terms/dmca'
import FanCreatorContract from 'pages/landingPage/terms/fancreatorcontract'
import PrivacyPolicy from 'pages/landingPage/terms/privacypolicy'
import ReferralTerms from 'pages/landingPage/terms/referralterms'
import Terms from 'pages/landingPage/terms/terms'
import USC from 'pages/landingPage/terms/usc'
import Placeholder from 'pages/messaging/components/Placeholder'
import InboxPage from 'pages/messaging/Inbox/InboxPage'
import { NewReel } from 'pages/reelCreate'
import { TicketCardOpen } from 'pages/support/pages/Tickets/components/TicketsList/pages/TickedCardOpen'
import { TermsAndPolicies } from 'pages/termsandpolicies'
import  TermsAndPoliciesTOS from 'pages/termsandpolicies/tos'
import { ModelVerification } from 'pages/verification'
import { useUserProfile } from 'store'

import ProtectedRoute from './ProtectedRoute'
import useBodyRouteClass from '../helpers/hooks/useBodyRouteClass/useBodyRouteClass';

const Router = () => {
    const settingsRoutes = useRenderSettingsRoutes()
    const userData = useUserProfile()!
    const navigate = useNavigate()
    const location = useLocation()
    const state = location.state as { backgroundLocation?: Location }
    useBodyRouteClass();
    const { isMobile } = useMobile()

    return (
        <>
            <Routes location={state?.backgroundLocation ?? location}>
            <Route
                path="/twitter-callback"
                element={<TwitterLogin />}
            />

            <Route
                path="/google-callback"
                element={<GoogleCallback />}
            />
                <Route element={<BasicLayout />}>
                        <Route
                        path={'/following'}
                        element={
                            <ProtectedRoute roles={['model', 'fan']}>
                            <Feed />
                            </ProtectedRoute>
                        }
                        />
                        <Route
                            path={'/referrals/:id'}
                            element={
                                <ProtectedRoute roles={['model']}>
                                    <Referrals />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={'/chat'}
                            element={
                                <ProtectedRoute roles={['model', 'fan']}>
                                    <InboxPage />
                                </ProtectedRoute>
                            }
                        >
                            <Route path={''} element={<Placeholder />} />
                            <Route path={':id'} element={<Conversation />} />
                        </Route>
                        <Route
                            path={'/earnings/:id'}
                            element={
                                <ProtectedRoute roles={['model']}>
                                    <Earnings />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={'/analytics/:id'}
                            element={
                                <ProtectedRoute roles={['model']}>
                                    <Analytics />
                                </ProtectedRoute>
                            }
                        />
                        <Route >
                            {settingsRoutes}
                        </Route>

                        <Route
                            path={'/fans'}
                            element={
                                <ProtectedRoute roles={['model']}>
                                    <Fans displayPage='home' />
                                </ProtectedRoute>
                            }
                        />
                            <Route
                                path={'/fans/:slug'}
                                element={
                                    <ProtectedRoute roles={['model']}>
                                        <Fans displayPage='group' />
                                    </ProtectedRoute>
                                }
                            />
                        <Route
                            path={'/friends'}
                            element={
                                <ProtectedRoute roles={['model']}>
                                    {userData?.overall_revenue > 200 ?
                                        <Friends />
                                        :
                                        <NotFound />
                                    }
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={'/streams'}
                            element={
                                <ProtectedRoute roles={['model']}>
                                    <StreamsArchive />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={'/model/:modelId/friends'}
                            element={<PublicFriends />}
                        />
                        <Route
                            path={'/support/:id'}
                            element={
                                <ProtectedRoute roles={['fan', 'model']}>
                                    <Support />
                                </ProtectedRoute>
                            }
                        />
                        <Route path={'/support/ticket/:id'} element={<TicketCardOpen />} />

                        <Route
                            path={'/how-to/:id?'}
                            element={
                                <ProtectedRoute roles={['fan', 'model']}>
                                    <HowTo />
                                </ProtectedRoute>
                            }
                        />
                        <Route path={'/how-to/tutorials/:id'} element={<Article />} />
                        <Route path={'/how-to/faq/:id'} element={<Article />} />
                        <Route
                            path={'/messages/new'}
                            element={
                                <ProtectedRoute roles={['fan', 'model']}>
                                    <NewMessage />
                                </ProtectedRoute>
                            }
                        />

                        <Route
                            path={'/new/post/create'}
                            element={
                                <ProtectedRoute roles={['model']}>
                                    <NewPost />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={'/edit/post/:id'}
                            element={
                                <ProtectedRoute roles={['model']}>
                                    <EditPost />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={'/notifications'}
                            element={
                                <ProtectedRoute roles={['fan', 'model']}>
                                    <Notifications />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={'/subscriptions/lists'}
                            element={
                                <ProtectedRoute roles={['fan', 'model']}>
                                    <Lists />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={'/subscriptions'}
                            element={
                                <ProtectedRoute roles={['fan', 'model']}>
                                    <Subscriptions />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={'/subscriptions/:id?'}
                            element={
                                <ProtectedRoute roles={['fan', 'model']}>
                                    <List />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={'/vault'}
                            element={
                                <ProtectedRoute roles={['model']}>
                                    <Vault />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={'/vault/:id'}
                            element={
                                <ProtectedRoute roles={['model']}>
                                    <Vault />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={'/watch/:username'}
                            element={
                                <ProtectedRoute roles={['fan', 'model']}>
                                    <Watch />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={'/creators'}
                            element={
                                <ProtectedRoute roles={['fan', 'model']}>
                                    <Creators />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={'/transactions'}
                            element={
                                <ProtectedRoute roles={['fan', 'model']}>
                                    <Transactions />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={'/media'}
                            element={
                                <ProtectedRoute roles={['fan', 'model']}>
                                    <Media />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={'/media_categories'}
                            element={
                                <ProtectedRoute roles={['model']}>
                                    <MediaCategories />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={'/watch-history'}
                            element={
                                <ProtectedRoute roles={['fan', 'model']}>
                                    <WatchHistory />
                                </ProtectedRoute>
                            }
                        />
<Route
  path="/discover/reels"
  element={
    <ProtectedRoute roles={['fan', 'model']}>
      <Discover />
    </ProtectedRoute>
  }
/>

<Route
  path="/discover/reels/:reelId"
  element={
    <ProtectedRoute roles={['fan', 'model']}>
      <Discover />
    </ProtectedRoute>
  }
/>

<Route
  path="/discover/reels/:reelId/profile"
  element={
    <ProtectedRoute roles={['fan', 'model']}>
      <Discover />
    </ProtectedRoute>
  }
/>
                        <Route
                            path={'/purchases'}
                            element={
                                <ProtectedRoute roles={['fan', 'model']}>
                                    <Purchases />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={'/likes'}
                            element={
                                <ProtectedRoute roles={['fan', 'model']}>
                                    <LikesHistory />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={'/playlists'}
                            element={
                                <ProtectedRoute roles={['fan', 'model']}>
                                    <Playlists />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={'/playlists/:id'}
                            element={
                                <ProtectedRoute roles={['fan', 'model']}>
                                    <MediaPlaylists />
                                </ProtectedRoute>
                            }
                        />

                        <Route
                            path={'/email/verify/:userId/:token'}
                            element={
                                <ProtectedRoute roles={['fan', 'model']}>
                                    <VerifyEmail />
                                </ProtectedRoute>
                            }
                        />

                        <Route
                            path={'/user-activity/:id'}
                            element={
                                <ProtectedRoute roles={['model']}>
                                    <UserActivity />
                                </ProtectedRoute>
                            }
                        />

                        <Route
                            path={'/trial-link/:id'}
                            element={
                                <ProtectedRoute roles={['model', 'fan']}>
                                    <Profile />
                                </ProtectedRoute>
                            }
                        />

                        <Route
                            path={'/schedule'}
                            element={
                                <ProtectedRoute roles={['model']}>
                                    <SchedulePage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={'/termsandpolicies'}
                            element={
                                <ProtectedRoute roles={['model', 'fan']}>
                                    <TermsAndPolicies />
                                </ProtectedRoute>
                            }
                        />
                        <Route path={'/404'} element={<NotFound />} />

                        <Route path={'*'} element={<NotFound />} />
                </Route>
                <Route element={<BasicLayout showFooterOnThisBranch />}>
                        <Route path='/:username' element={
                            <ProtectedRoute roles={['model', 'fan']} allowPublic>
                            <Profile />
                            </ProtectedRoute>
                        } />

                </Route>
                {/* Public routes (NO layout) */}
                <Route path="/become-a-creator" element={
                    <ProtectedRoute roles={['fan', 'model']}>
                        <ModelVerification />
                    </ProtectedRoute>
                } />
                <Route
                    path={'/menu'}
                    element={
                        <ProtectedRoute roles={['fan', 'model']}>
                            <Menu />
                        </ProtectedRoute>
                    }
                />
                <Route path={'/post/:id'} element={
                    <ProtectedRoute roles={['fan', 'model']}>
                        <Post />
                    </ProtectedRoute>
                 } />        
<Route element={isMobile ? <Outlet /> : <BasicLayout />}>
    <Route
        path="/new/story"
        element={
            <ProtectedRoute roles={['model']}>
                <NewStory />
            </ProtectedRoute>
        }
    />

    <Route
        path="/new/reel"
        element={
            <ProtectedRoute roles={['model']}>
                <NewReel />
            </ProtectedRoute>
        }
    />
</Route>
                <Route
                    path={'/live'}
                    element={
                        <ProtectedRoute roles={['model']}>
                            <Live />
                        </ProtectedRoute>
                    }
                />
                <Route
                path="/reset-password"
                element={
                    <AuthModalProvider>
                    <Auth />
                    </AuthModalProvider>
                }
                />
<Route
    element={
        !isMobile
            ? <LandingPage />
            : <Outlet />
    }
>
    <Route
        path="/"
        element={
            !isMobile
                ? <Main />
                : <HomeRouter />
        }
    />

    <Route
        path="/terms"
        element={
            !isMobile
                ? <Terms />
                : <TermsModal onClose={() => navigate(-1)} />
        }
    />

    <Route
        path="/dmca"
        element={
            !isMobile
                ? <DMCA />
                : <DMCAModal onClose={() => navigate(-1)} />
        }
    />

    <Route
        path="/privacypolicy"
        element={
            !isMobile
                ? <PrivacyPolicy />
                : (
                    <PrivacyPolicyModal
                        onClose={() => navigate(-1)}
                    />
                )
        }
    />

    <Route
        path="/acceptableuse"
        element={
            !isMobile
                ? <AcceptableUse />
                : (
                    <AcceptableUseModal
                        onClose={() => navigate(-1)}
                    />
                )
        }
    />

    <Route
        path="/usc"
        element={
            !isMobile
                ? <USC />
                : <USCModal onClose={() => navigate(-1)} />
        }
    />

    <Route
        path="/referralterms"
        element={
            !isMobile
                ? <ReferralTerms />
                : (
                    <ReferralTermsModal
                        onClose={() => navigate(-1)}
                    />
                )
        }
    />

    <Route
        path="/cookiepolicy"
        element={
            !isMobile
                ? <CookiePolicy />
                : (
                    <CookiePolicyModal
                        onClose={() => navigate(-1)}
                    />
                )
        }
    />

    <Route
        path="/complaintspolicy"
        element={
            !isMobile
                ? <ComplaintsPolicy />
                : (
                    <ComplaintsPolicyModal
                        onClose={() => navigate(-1)}
                    />
                )
        }
    />

    <Route
        path="/fancreatorcontract"
        element={
            !isMobile
                ? <FanCreatorContract />
                : (
                    <FanCreatorContractModal
                        onClose={() => navigate(-1)}
                    />
                )
        }
    />

    <Route
        path="/creatorterms"
        element={
            !isMobile
                ? <CreatorTerms />
                : (
                    <CreatorTermsModal
                        onClose={() => navigate(-1)}
                    />
                )
        }
    />

    <Route
        path="/ccpapolicy"
        element={
            !isMobile
                ? <CCPAPolicy />
                : (
                    <CCPAPolicyModal
                        onClose={() => navigate(-1)}
                    />
                )
        }
    />

    <Route
        path="/cookietable"
        element={
            !isMobile
                ? <CookieTable />
                : (
                    <CCPAPolicyModal
                        onClose={() => navigate(-1)}
                    />
                )
        }
    />

    <Route
        path="/biometricnotice"
        element={
            !isMobile
                ? <BiometricNotice />
                : (
                    <BiometricNoticeModal
                        onClose={() => navigate(-1)}
                    />
                )
        }
    />

    <Route
        path="/contentmoderationpolicy"
        element={
            !isMobile
                ? <ContentModerationPolicy />
                : (
                    <ContentModerationPolicyModal
                        onClose={() => navigate(-1)}
                    />
                )
        }
    />
</Route>

<Route
    path="/:type"
    element={
        <AuthModalProvider>
            <Auth />
        </AuthModalProvider>
    }
/>
                <Route path="/termsandpolicies/tos" element={!isMobile ? <TermsAndPoliciesTOS /> : <TermsModal />} />


                <Route path="/vmc/identity-verification/callback" element={<VerifyMyAgeCallback />} />
                {/* Add all other public pages here */}
                <Route path="*" element={<NotFound />} />
            </Routes>
        </>
    )
}

export default Router